<div
  class="sidebar-searchbar searchbar relative flex w-full justify-between gap-2 overflow-hidden rounded-3xl px-4 py-2"
  [style]="'font-size:' + fontSize()"
  [class]="surfaceClass()"
  #searchBar
>
  @if (!hideSearchIcon()) {
    <span
      class="material-icons unselectable flex-shrink-0"
      [class.text-primary]="!aiSearch()"
      [class.text-ai-shade-2]="aiSearch()"
      [class]="!searchDisabled() ? 'cursor-pointer' : '!text-[var(--mat-sys-outline)]'"
      [style]="'font-size:' + iconSize() + ';width: ' + iconSize() + ';height: ' + iconSize()"
      (click)="search()"
    >
      search
    </span>
  }
  <input
    [disabled]="searchDisabled()"
    type="text"
    class="border-none outline-none"
    [placeholder]="'Ricerca' | siaTranslate"
    [ngModel]="searchExp()"
    (ngModelChange)="onSearchExpChange($event)"
    (keyup.enter)="search()"
  />
  @if (searchExp()) {
    <span
      class="material-icons text-primary unselectable cursor-pointer"
      [style]="'font-size:' + iconSize() + ';width: ' + iconSize() + ';height: ' + iconSize()"
      (click)="clear()"
      >close</span
    >
  }
</div>
